/**
 * Route redirect mở dialog đăng nhập/đăng ký trên trang chủ.
 *
 * Chuyển về home kèm state openLogin/openRegister và giữ returnTo từ location.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../shared/constants/routes';

const createAuthDialogRedirect = (dialogKey) => () => {
  const location = useLocation();
  const returnTo = location.state?.from
    ? `${location.state.from.pathname}${location.state.from.search || ''}${location.state.from.hash || ''}`
    : location.state?.returnTo;

  return (
    <Navigate
      to={APP_ROUTES.home}
      replace
      state={{
        [dialogKey]: true,
        returnTo,
      }}
    />
  );
};

export const LoginRedirect = createAuthDialogRedirect('openLogin');
export const RegisterRedirect = createAuthDialogRedirect('openRegister');
